import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import download from '../images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import { IconButton, Box, Grid } from "@mui/material";
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import ReportsAGGrid from "../reportsGrid/reportsAGGrid";
import CloseIcon from '@mui/icons-material/Close';

const styles = theme => ({
    root: {
        width: "100%",
    },
    spinner: {
        position: 'absolute',
        background: 'rgba(255,255,255,.4)',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        top: 0,
        left: 0,
    },
    spinnerImage: {
        top: 'calc(50% - 32.5px)',
        left: 'calc(50% - 65px)',
        position: 'absolute',
        width: '130px',
        userSelect: 'none'
    },
});

let TransactionFilterObj = {
    searchObject: null,
    order_timestamp: {
        fromdate: '',
        todate: ''
    },
    expiry_date: {
        fromdate: '',
        todate: ''
    },
    order_reciept_date: {
        fromdate: '',
        todate: ''
    },
    pageNo: 0,
    pageSize: 25,
    sortOrder: 'desc',
    sortColumn: 'order_timestamp',
    tableName: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rowsPerPage: 25,
            loader: false,
        };
    }

    convertToTimeZone = (requestDate) => {
        const currentUserLang = localStorage.getItem('i18nextLng');
        let zone;
        zone = sessionStorage.getItem('timeZone');
        const date = moment(new Date(requestDate));
        if (['null', null, 'undefined', undefined].includes(zone)) {
            zone = defaultZone;
        }
        return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
    }

    exportCSV() {
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + "CSV/VendorOrdersReport", {
            method: 'POST',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(TransactionFilterObj)
        })
            .then(response => response.json())
            .then(csvData => {
                this.setState({ loader: false });
                let csvRow = [];
                let Array = [['ID', 'Order ID', 'Order Timestamp', 'Store NCPDP', 'Patient ID', 'First Name', 'Last Name', 'Gender', 'DOB', 'Email', 'Phone', 'Prescription Number', 'Drug Name', 'NDC Code', 'Transaction ID', 'Fill ID', 'Prescription ID', 'Amount Due', 'Dispensed Qty', 'Expiry Date', 'Order Receipt Date']];
                let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
                if (result !== undefined && result !== 'undefined') {
                    if (result && result.length > 0) {
                        for (let i of result) {
                            Array.push(
                                [
                                    i.order_id,
                                    i.order_timestamp ? this.convertToTimeZone(i && i.order_timestamp) : '',
                                    i.store_ncpdp,
                                    i.patient_id,
                                    i.first_name,
                                    i.last_name,
                                    i.gender,
                                    i.dob,
                                    i.email,
                                    i.sms_phone,
                                    i.prescription_number,
                                    i.drug_name ? i.drug_name.replaceAll(',', ' ').trim() : '',
                                    i.ndc,
                                    i.prescription_txn_id,
                                    i.fillid,
                                    i.prescription_id,
                                    i.amount_due ? '$' + parseFloat(i.price).toFixed(2) : '$0.00',
                                    i.dispensed_qty,
                                    i.expiry_date ? this.convertToTimeZone(i && i.expiry_date) : '',
                                    i.order_reciept_date ? this.convertToTimeZone(i && i.order_reciept_date) : '',
                                ]
                            );
                        }

                        for (let i of Array) {
                            csvRow.push(i.join(","));
                        }
                        let csvString = csvRow.join("%0A");
                        let element = document.createElement("a");
                        element.href = 'data:attachment/csv.' + csvString;
                        element.target = "_Blank";
                        element.download = "VendorOrdersReport.csv";
                        document.body.appendChild(element);
                        element.click();
                    }
                }
            })
    };

    onGridReady = (params) => {
        this.gridApi = params.api
        const datasource = this.getServerSideDatasource()
        // register datasource with the grid
        this.gridApi.setServerSideDatasource(datasource);
    }

    clearFilters = () => {
        const filterModel = this.gridApi.getFilterModel();
        if (Object.keys(filterModel).length > 0) {
            this.gridApi.setFilterModel(null);
            TransactionFilterObj.searchObject = null;
            TransactionFilterObj.order_timestamp.fromdate = '';
            TransactionFilterObj.order_timestamp.todate = '';
            TransactionFilterObj.expiry_date.fromdate = '';
            TransactionFilterObj.expiry_date.todate = '';
            TransactionFilterObj.order_reciept_date.fromdate = '';
            TransactionFilterObj.order_reciept_date.todate = '';
            this.gridApi.refreshServerSide();
        }
    };

    getServerSideDatasource = () => {
        const self = this;
        return {
            getRows(params) {
                TransactionFilterObj.pageNo = Math.floor(params.request.startRow / self.state.rowsPerPage)

                const filterObject = params.request && params.request.filterModel
                const filterColumns = Object.keys(filterObject)

                // to set fromdate and todate
                if (filterObject.order_timestamp) {
                    const dateValue = filterObject.order_timestamp;
                    if (dateValue.operator) {
                        // for date range
                        if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
                            const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
                            const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
                            TransactionFilterObj.order_timestamp.fromdate = date1
                            TransactionFilterObj.order_timestamp.todate = date2
                        }
                        if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
                            const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
                            const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
                            TransactionFilterObj.order_timestamp.fromdate = date1
                            TransactionFilterObj.order_timestamp.todate = date2
                        }
                    } else {
                        // for from/to date
                        const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
                        if (dateValue.type === 'fromdate') {
                            TransactionFilterObj.order_timestamp.fromdate = date
                            TransactionFilterObj.order_timestamp.todate = ''
                        } else {
                            TransactionFilterObj.order_timestamp.todate = date
                            TransactionFilterObj.order_timestamp.fromdate = ''
                        }
                    }
                } else {
                    TransactionFilterObj.order_timestamp.todate = '';
                    TransactionFilterObj.order_timestamp.fromdate = ''
                }

                // to set fromdate and todate
                if (filterObject.expiry_date) {
                    const dateValue = filterObject.expiry_date;
                    if (dateValue.operator) {
                        // for date range
                        if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
                            const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
                            const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
                            TransactionFilterObj.expiry_date.fromdate = date1
                            TransactionFilterObj.expiry_date.todate = date2
                        }
                        if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
                            const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
                            const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
                            TransactionFilterObj.expiry_date.fromdate = date1
                            TransactionFilterObj.expiry_date.todate = date2
                        }
                    } else {
                        // for from/to date
                        const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
                        if (dateValue.type === 'fromdate') {
                            TransactionFilterObj.expiry_date.fromdate = date
                            TransactionFilterObj.expiry_date.todate = ''
                        } else {
                            TransactionFilterObj.expiry_date.todate = date
                            TransactionFilterObj.expiry_date.fromdate = ''
                        }
                    }
                } else {
                    TransactionFilterObj.expiry_date.todate = '';
                    TransactionFilterObj.expiry_date.fromdate = ''
                }

                // to set fromdate and todate
                if (filterObject.order_reciept_date) {
                    const dateValue = filterObject.order_reciept_date;
                    if (dateValue.operator) {
                        // for date range
                        if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
                            const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
                            const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
                            TransactionFilterObj.order_reciept_date.fromdate = date1
                            TransactionFilterObj.order_reciept_date.todate = date2
                        }
                        if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
                            const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
                            const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
                            TransactionFilterObj.order_reciept_date.fromdate = date1
                            TransactionFilterObj.order_reciept_date.todate = date2
                        }
                    } else {
                        // for from/to date
                        const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
                        if (dateValue.type === 'fromdate') {
                            TransactionFilterObj.order_reciept_date.fromdate = date
                            TransactionFilterObj.order_reciept_date.todate = ''
                        } else {
                            TransactionFilterObj.order_reciept_date.todate = date
                            TransactionFilterObj.order_reciept_date.fromdate = ''
                        }
                    }
                } else {
                    TransactionFilterObj.order_reciept_date.todate = '';
                    TransactionFilterObj.order_reciept_date.fromdate = ''
                }

                if (filterObject) {
                    if (filterColumns.length === 0) {
                        TransactionFilterObj.searchObject = null
                    } else {
                        TransactionFilterObj.searchObject = filterObject
                    }
                }

                if (params.request.sortModel.length > 0) {
                    TransactionFilterObj.sortColumn = params.request.sortModel[0].colId.sortColumn
                    TransactionFilterObj.sortOrder = params.request.sortModel[0].sort
                }

                apiCall()

                function apiCall() {
                    self.setState({ loader: true });
                    fetch(process.env.REACT_APP_BASEURL + 'api/v1/subscriptions/prescriptionManagement/allVendorOrders', {
                        method: 'post',
                        withCredentials: true,
                        headers: {
                            Authorization:
                                'Bearer ' +
                                JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                                    .jwtToken,
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(TransactionFilterObj),
                    })
                        .then((httpResponse) => {
                            try {
                                return httpResponse.json();
                            } catch (error) {
                                return null;
                            }
                        })
                        .then((response) => {
                            if (response && response.results) {
                                if (response.results.length > 0) {
                                    params.successCallback(response.results, response.total);
                                    self.setState({ data: response.results, isButtonDisabled: false })
                                } else {
                                    params.successCallback([], 0);
                                    self.setState({ data: [], isButtonDisabled: true })
                                }
                                self.setState({ loader: false })
                            }
                        })
                        .catch(error => {
                            self.setState({ loader: false })
                            console.error(error);
                            params.failCallback();
                        });
                }
            }
        };
    }

    DateCellFormatter = (params) => {
        return this.convertToTimeZone(params.value)
    }

    AmountValueRenderer = (params) => {
        return params.value ? '$' + parseFloat(params.value).toFixed(2) : '$0.00'
    }

    render() {
        const { classes, t } = this.props;
        const { data } = this.state;

        const columnDefs = [
            { field: "order_id", headerName: t("Report.OrderStaging.OrderID") },
            {
                field: "order_timestamp", headerName: t("Report.OrderStaging.OrderTimestamp"),
                cellRenderer: this.DateCellFormatter,
                filter: 'agDateColumnFilter',
                filterParams: {
                    filterOptions: [
                        {
                            displayKey: 'fromdate',
                            displayName: t('Report.OrderStaging.FromDate'),
                            predicate: (_, cellValue) => cellValue
                        },
                        {
                            displayKey: 'todate',
                            displayName: t('Report.OrderStaging.ToDate'),
                            predicate: (_, cellValue) => cellValue
                        },
                    ],
                    maxNumConditions: 2,
                },
            },
            { field: "store_ncpdp", headerName: t("Report.OrderStaging.StoreNCPDP") },
            { field: "patient_id", headerName: t("Report.OrderStaging.PatientID") },
            { field: "first_name", headerName: t("Report.OrderStaging.FirstName") },
            { field: "last_name", headerName: t("Report.OrderStaging.LastName") },
            { field: "gender", headerName: t("Report.OrderStaging.Gender") },
            { field: "dob", headerName: t("Report.OrderStaging.DOB") },
            { field: "email", headerName: t("Report.OrderStaging.Email") },
            { field: "sms_phone", headerName: t("Report.OrderStaging.Phone") },
            { field: "prescription_number", headerName: t("Report.OrderStaging.PrescriptionNumber") },
            { field: "drug_name", headerName: t("Report.OrderStaging.DrugName") },
            { field: "ndc", headerName: t("Report.OrderStaging.NDCCode") },
            { field: "prescription_txn_id", headerName: t("Report.OrderStaging.TransactionID") },
            { field: "fillid", headerName: t("Report.OrderStaging.FillID") },
            { field: "prescription_id", headerName: t("Report.OrderStaging.PrescriptionID") },
            { field: "amount_due", headerName: t("Report.OrderStaging.AmountDue"), filter: false, cellRenderer: this.AmountValueRenderer },
            { field: "dispensed_qty", headerName: t("Report.OrderStaging.DispensedQty"), filter: false },
            {
                field: "expiry_date", headerName: t("Report.OrderStaging.ExpiryDate"),
                cellRenderer: this.DateCellFormatter,
                filter: 'agDateColumnFilter',
                filterParams: {
                    filterOptions: [
                        {
                            displayKey: 'fromdate',
                            displayName: t('Report.OrderStaging.FromDate'),
                            predicate: (_, cellValue) => cellValue
                        },
                        {
                            displayKey: 'todate',
                            displayName: t('Report.OrderStaging.ToDate'),
                            predicate: (_, cellValue) => cellValue
                        },
                    ],
                    maxNumConditions: 2,
                },
            },
            {
                field: "order_reciept_date", headerName: t("Report.OrderStaging.OrderReceiptDate"),
                cellRenderer: this.DateCellFormatter,
                filter: 'agDateColumnFilter',
                filterParams: {
                    filterOptions: [
                        {
                            displayKey: 'fromdate',
                            displayName: t('Report.OrderStaging.FromDate'),
                            predicate: (_, cellValue) => cellValue
                        },
                        {
                            displayKey: 'todate',
                            displayName: t('Report.OrderStaging.ToDate'),
                            predicate: (_, cellValue) => cellValue
                        },
                    ],
                    maxNumConditions: 2,
                },
            },
        ];

        return (
            <Paper id="react-no-print" className={classes.root}>
                {
                    this.state.loader ?
                        <div className={classes.spinner}>
                            <img className={classes.spinnerImage} src={spinner} alt="loading" />
                        </div> :
                        null
                }
                <div id="react-no-print">
                    <Box component="div">
                        <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={0} sx={{ ml: 0, mr: 1, width: '100%', border: 'solid 1px #babfc7', borderBottom: 'none' }}>
                            <Grid item xs={3} md={3} sx={{ textAlign: 'end' }}>
                                <Tooltip key="clear-filters" title={t("Report.OrderStaging.ClearFiltersTooltip")}>
                                    <IconButton onClick={() => this.clearFilters()} style={{ backgroundColor: "#00a7e1" }}>
                                        <CloseIcon style={{ color: "white" }} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip key="export-csv" title={t("Report.OrderStaging.ExportCSVTooltip")}>
                                    <IconButton
                                        style={{ marginRight: '0' }}
                                        aria-label="ExportCSV"
                                        disabled={this.state.isButtonDisabled}
                                    >
                                        <img alt="download" onClick={() => { this.exportCSV() }} src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Box>
                    <ReportsAGGrid
                        columnDefs={columnDefs}
                        sideBar={false}
                        suppressMenuHide={true}
                        rowData={data}
                        defaultColDef={{
                            flex: 1,
                            minWidth: 150,
                            floatingFilter: true,
                            filter: 'agTextColumnFilter',
                            filterParams: {
                                filterOptions: [{
                                    displayKey: 'searchtext',
                                    displayName: 'Search Text',
                                    predicate: (cellValue) => cellValue
                                }],
                                maxNumConditions: 1,
                            },
                            resizable: true,
                            sortable: true,
                            menuTabs: ['generalMenuTab', 'columnsMenuTab'],
                        }}
                        onGridReady={this.onGridReady}
                    />
                </div>
            </Paper>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/vendor-orders/index.js